import { ButtonCollapsible } from '@bgea-js/design-library';
import Donation from "../../../../src/content/last-flight-out-movie/donation.mdx";
import * as React from 'react';
export default {
  ButtonCollapsible,
  Donation,
  React
};